__turbopack_context__.v({
  "dash": "videospinnerloader-module-scss-module__xk0pWW__dash",
  "loaderWrapper": "videospinnerloader-module-scss-module__xk0pWW__loaderWrapper",
  "overlay": "videospinnerloader-module-scss-module__xk0pWW__overlay",
  "path": "videospinnerloader-module-scss-module__xk0pWW__path",
  "rotate": "videospinnerloader-module-scss-module__xk0pWW__rotate",
  "spinner": "videospinnerloader-module-scss-module__xk0pWW__spinner",
});
